import script from "./paymethods-label.vue?vue&type=script&setup=true&lang=js"
export * from "./paymethods-label.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__